module.exports = {
  Range: '范围',
  SorryHavePermissionToInformation: '对不起!您没有权限查看详细信息.',
  BusinessInformationSelectionIncorrect: '业务信息选择不正确.',
  DidOnThePreviousDay: '前一天未报好关',
  DeclaredSameDayAsFlight: '当天报关当天航班',
  DeclaredOnTheSameDay: '当天报关',
  Other: '其他',
  PleaseTheCustomsDeclarationList: '请选择报关清单.',
  LabelPrintingSucceeded: '标签打印成功.',
  ConfirmAudit: '确定审核吗？',
  PleaseTheMasterBillInformation: '请选择主单信息.',
  TheNumberHasBeenInvalidated: '此主单号已经作废了.',
  CancellationSuccessful: '作废成功.',
  CancellationFail: '作废失败.',
  ConfirmBillNumberFromBusiness: '确认此主单号与业务之前解除绑定吗?',
  UnbindingFailed: '解绑失败.',
  UnbindingSuccessful: '解绑成功.',
  MasterBill: '主单',
  SubBill: '分单',
  MasterBillStatus: '主单状态',
  SubBillStatus: '分单状态',
  EnterQueryInformation: '请输入查询信息!',
  ConfirmThis: '确认将这',
  ReceiptNumber: '回单号',
  AllFlightMustBeLocking: '当前航班下单子必全都提交后才能锁定!',
  OtherDocuments: '其他文件',
  CustomsDeclarationDocuments: '报关文件',
  PleaseImageYouWantUpload: '请选择要上传的图片.',
  InvalidReceiptNumber: '无效的回执单号!',
  InvalidMasterBillNumber: '主单号无效.',
  NoContactTheAirlineImages: '该运单号未配航班,请与航线联系配航班后再上传图片.',
  PleaseFileYouWantDownload: '请选择需要下载的文件.',
  UploadWantToUploadImage: '上传成功,是否上传下一号码的照片?',
  BulkEditingDestinationPortInformation: '批量修改目的港信息',
  OverseasWarehouseNonAmazonWarehouse: '海外中转仓非亚马逊仓',
  EstimatedArrivalTime: '预计送达时间',
  ActualArrivalTime: '实际送达时间',
  NoDataSelected: '未选择数据',
  AllAreInNonState: '选择的数据记录全部为非【正操作】状态',
  TheIsNotSelfConsolidation: '该票业务整拼类型不是自拼箱、buyer consol、委托拼箱',
  AttachmentTooLarge: '附件内容过大',
  BusinessStatusChangeLog: '业务状态变更日志',
  DomesticWarehouse: '国内仓',
  OverseasWarehouse: '国外仓',
  LogRecords: '日志记录',
  GeneralTrade: '一般贸易',
  OperationSuccessful: '操作成功',
  PleaseChooseAnAirline: '请选择航线!',
  ContainerType: '箱种',
  Size: '箱型',
  LockedPleaseContactSupervisorUnlocking: '已被锁定,不能打印,请联系上级主管解锁!',
  ProfitAnalysisPrint: '利润分析打印',
  DoCopyMasterBillInformation: '确定要抄录主单收发货人信息吗？',
  DeleteSucceeded: '删除成功！',
  PleaseFormatOfTheLengthwidthheightquantity: '请输入正确格式的尺寸:长*宽*高*件数！',
  GenerationFailed: '生成失败！',
  CargoCollectionType: '揽货类型',
  Commission: '委托',
  CustomsClearanceMethod: '清关方式',
  ServiceChannel: '服务渠道',
  ExpectedTimeIntoAmazonWarehouse: '预期入亚马逊仓时间',
  ZipCode: '邮编',
  DestinationDeliveryMethod: '目的地配送方式',
  ExpressCompany: '快递公司',
  CourierNumber: '快递单号',
  POOriginalOrderNumber: 'PO(原单号)',
  EORIBusinessNumber: 'EORI企业号',
  VATTaxNumber: 'VAT/税号',
  VATRegistrationCountry: 'VAT注册国家',
  VATRegistrationAddress: 'VAT注册地址',
  VATCompanyEnglishName: 'VAT公司英文名',
  EstimatedDeliveryTime: '预计送达时间',
  ActualDeliveryTime: '实际送达时间',
  WithBattery: '带电',
  WithMagnet: '带磁',
  Powder: '粉末',
  Liquid: '液体',
  EstimatedStorageGoodArrivalTime: '预计入库/货好时间',
  RemoteWarehouse: '偏远仓',
  AirFreight: '空运费',
  FeeType: '费用类型：',
  EstimatedAmount: '预估金额：',
  Equivalent: '折合',
  FreightRateLevel: '运价级别：',
  BilledWeight: '计费重量：',
  CalculationMethod: '计算方式：',
  EstimatedTimeCannotBeEmpty: '预计入仓/货好时间不能为空！',
  DestinationCannotBeEmpty: '目的地不能为空！',
  DestinationCountryCannotBeEmpty: '目的国不能为空！',
  ZipCodeCannotBeEmpty: '邮编不能为空！',
  CannotBeEmpty: '不能为空！',
  InvalidBillNumberCannotBind: '无效的主单号，不能绑定!',
  PleaseTheConsignorUnitFirst: '请先选择委托单位。',
  TheExpensesCanNotMode: '当前小票有分摊费用，不能切换操作模式！',
  DoRefreshTheMAWBInformation: '是否刷新MAWB相关信息？',
  CourierCompany: '快递公司',
  ForeignWarehouse: '国外仓',
  CustomsDeclarationMethod: '报关方式',
  TheSharedExpensesCanSeparate: '当前小票有分摊费用,不能分离!',
  RemoveTicketSuccessfully: '移除小票成功！',
  AttachmentDescription: '附件说明：',
  AirlineCannotBeEmpty: '航空公司不能空',
  AddNew: '新增',
  NoItemDetailsSelected: '未选择货物明细!',
  SellingPriceCalculationCompleted: '卖价计算完成',
  PleaseSelectWarehouseEntryData: '请选择进仓数据！',
  DeletedSuccessfully: '删除成功！',
  PleaseAPieceOfData: '请选择一条数据！',
  CustomsClearanceTracking: '报关跟踪',
  CustomsClearanceQuantity: '报关件数',
  CustomsClearanceWeight: '报关重量',
  CustomsClearanceDate: '报关日期',
  CustomsClearanceInformation: '报关信息',
  MultipleCustomsDeclarations: '多个报关单',
  WhetherApplyForCommercialInspection: '是否商检',
  WhetherToCheck: '是否查验',
  PleaseSelectCustomsClearanceInformation: '请选择报关信息.',
  TheBeEqualToBusiness: '报关件重的总和必须和业务的实际件重相等.',
  NextLegEntry: '续程录入',
  ActualFlight: '实际航班：',
  NextLegInformation: '续程信息：',
  ActualFlightCannotBeEmpty: '实际航班不能为空.',
  ActualDepartureDate: '实际开航日期.',
  NextInformationCannotBeEmpty: '续程信息不能为空.',
  BatchModificationOfReportStatus: '批量修改报表状态',
  CustomsClearanceStatus: '报关状态：',
  PleaseSelectCustomsClearanceStatus: '请选择报关状态.',
  SelectAirPort: '选择空运港口',
  PleaseSelectAPort: '请选择港口!',
  FlightSelection: '航班选择',
  Monday: '一',
  Tuesday: '二',
  Wednesday: '三',
  Thursday: '四',
  Friday: '五',
  Saturday: '六',
  Sunday: '日',
  FlightSchedule: '航期',
  Weekly: '每周',
  PleaseSelectAFlight: '请选择一个航班.',
  PleaseEnterACode: '请输入代码!',
  CodeExistsPleaseReEnter: '代码已经存在，请重新输入!',
  PleaseEnterAName: '请输入名称!',
  PleaseAddARegionalPort: '请添加区域港口!',
  AreYouWantToDelete: '确定要删除吗?',
  PleaseTheDepartureRegionCode: '请输入起运区域代码!',
  PleaseTheDestinationRegionCode: '请输入目的区域代码!',
  DepartureRegionCodeCannotSame: '起运区域代码与目的区域代码不能相同!',
  WeeklySchedule: '班期',
  PleaseEffectiveDateStartTime: '请选择有效期开始时间!',
  PleaseSelectTheSchedule: '请选择班期!',
  PleaseEnterTheTransshipmentPort: '请输入转运港口.',
  AreWantToDeleteRoute: '确定要删除线路吗?',
  GenerateFlight: '生成航班',
  PleaseEnterAFlightNumber: '请输入航班号!',
  PleaseEnterAnAirline: '请输入航空公司!',
  PleaseEnterTheDeparturePort: '请输入起运港!',
  PleaseEnterTheDestinationPort: '请输入目的港!',
  PleaseDepartureTimeForWeek: '请输入周',
  AreWantToDeleteFlight: '确定要删除航班吗?',
  TheWantToDeleteRegenerate: '已经生成航班，是否删除原信息重新生成?',
  GenerationSuccessful: '生成成功.',
  AtBookingNatureAirportEntered: '航线、航空公司、订舱性质、空港、销售至少录入其中一项！',
  ResponsibilitiesAssignedNoDeletionAllowed: '职责已经分配，不允许删除!',
  AreToDeleteThisRecord: '确定要删除这条记录吗?',
  TheTheAirlineIsModify: '航空公司三字码维护有误，请修改！',
  PleaseSelectAnAirline: '请选择航空公司!',
  PleaseSelectTheExpirationDate: '请选择失效日期!',
  PleaseStartingMasterBillNumber: '请输入起始主单号!',
  TheLegalThereIsAirline: '起始号不合法，没有匹配的航空公司!',
  TheNumberIsNotLegal: '主单号不合法!',
  PleaseTheDateOfPossession: '请选择领用日期!',
  TheMasterBillMayExist: '当前号码段主单号可能已经存在!',
  ConfirmDeleteTheMasterBill: '确认要删除主单?',
  CancelSubmission: '取消提交',
  SaveSuccessfully: '保存成功!',
  SaveSuccess: '保存成功',
  PleaseTheWarehouseEntryNumber: '请输入进仓编号!',
  PleaseWeightOfTheSeal: '请选关封重量!',
  PleaseEnterTheWarehouseName: '请输入仓库名称!',
  ReviewSucceeded: '审核成功！',
  LockedContactAHigherUnlock: '已被锁定,不能打印,请联系上级主管解锁!',
  PleasePortOfDepartureDestination: '请输入一个起运港或目的港!',
  SaveFileFormatIsIncorrect: '保存失败,Excel文件格式不正确!',
  SuccessfullyImported: '成功导入',
  PiecesOfData: '条数据!',
  SaveFailed: '保存失败!',
  PleaseThePortOfDeparture: '请输入起运港!',
  CompleteOperationRequirements: '完成操作要求',
  PleaseSelectTheCompletionTime: '请选择完成时间.',
  CurrentlySelected: '(当前选择)',
  CurrentPage: '(当前页)',
  CompletionStatus: '完成状态',
  Completed: '已完成',
  Uncompleted: '未完成',
  OperationRequirementDescription: '操作要求说明',
  CurrentSelectionIncludesCompletedStatus: '当前选择包含了已完成状态.',
  OperationRequirementTracking: '操作要求跟踪',
  ConfirmCancellation0: '确定作废[{0}]号吗？',
  DeDepartureTime: '的起飞时间.',
  AERequiredChecksum: '主单起始号、批量新增必填其一',
  FlightInformation: '航班信息',
  TrackingDetails: '运踪详情',
  StartingStation: '起始站',
  DestinationStation: '目的站',
  FlightNumber: '航班号',
  DepartureTime: '出发时间',
  ArrivalTime: '到达时间',
  Pieces: '件数',
  Weight: '重量',
  Time: '时间',
  Status: '状态',
  Airport: '机场',
  Unknown: '未知',
  BKD: '订舱',
  RCS: '进仓',
  MAN: '配载',
  DEP: '起飞',
  ARR: '抵达',
  AWD: '收单',
  RCF: '卸货',
  NFD: '到货通知',
  DLV: '提货',
  TAR: '中转抵达',
  TDE: '中转起飞',
  TRF: '中转卸货',
  RWB: '收单',
  CUS: '清关',
  AeMawbChargeWeight: '空运制单计费重量',
  AeBookingChargeWeight: '空运订舱计费重量',
  MawbChargeWeight: '制单计费重量',
  BookingChargeWeight: '订舱计费重量',
  ImportBoardInstallInfo: '导入装板信息',
  PleaseImportCorrectTemplate: '请导入正确模版的信息',
  ClickDownloadTemplate: '可点击下载模版',
  AsyncUploadLogView: '此操作为异步操作，您可在“文件存储->上传日志”中查看导入结果',
  ServiceInformation: '服务信息',
  ControlDisplayConfiguration: '控件显示配置',
  WovenFabricorder: '件毛体(委托)',
  BookingForCargobooking: '件毛体(订舱)',
  ItemMaoTiForwardWarehouseActual: '件毛体(前置仓（实际）)',
  ItemMaoTiOrderProcessing: '件毛体(制单)'
}
